<template>
  <div>
    <v-sheet
      color="primary"
      class="pa-3 ma-3 mt-3 white--text gradient ml-8"
      style="display:grid; grid-template-columns: 1fr max-content max-content max-content; align-items:center;border-radius: 1rem;"
    >
      <div
        class="primary pa-2 ml-3"
        style="text-align:center;position:absolute;left: 0rem;top:5.5rem;border-radius: 50%;"
      >
        <sabira_icon
          icon="expense"
          :height="44"
          :width="44"
          class="pa-2"
          fill="#fff"
        ></sabira_icon>
      </div>
      <div style="display:grid;" class="ml-10">
        <div
          style="font-size: 1rem;font-family: 'Open Sans';font-weight: 700;color:#fff"
        >
          ISPLATE
        </div>
      </div>

      <sabira_invoice_progress_bar
        :status="{ min: 0, max: total_billed, current: total_paid }"
      ></sabira_invoice_progress_bar>

      <div class="mr-4">Zapisi: {{ items.length }}</div>
      <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="new_item()"
            color="transparent"
            depressed
            icon
            v-bind="attrs"
            v-on="on"
          >
            <sabira_icon
              icon="plus"
              :strokewidth="3"
              :width="34"
              :height="34"
              fill="white"
            ></sabira_icon>
          </v-btn>
        </template>
        <span>Nova isplata</span>
      </v-tooltip>
    </v-sheet>
    <v-card class="ma-4" flat color="tertiary" style="border-radius: 1rem;">
      <v-card-text>
        <div
          style="display:grid;grid-template-columns: 1fr max-content max-content; align-items: center; grid-column-gap: 1rem;"
        >
          <v-text-field
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Pretraga isplata"
            placeholder="Unesite naziv pojma za pretragu"
            v-model="search_text"
            outlined
          ></v-text-field>
          <v-select
            class="select"
            mandatory
            :items="years"
            outlined
            hide-details
            label="Godina"
            v-model="selected_year"
          />
          <sabira_invoice_header></sabira_invoice_header>
        </div>
        <v-card flat v-if="is_loading">
          <v-skeleton-loader type="table, list-item@6" />
        </v-card>
        <template v-else>
          <v-data-table
            style="background: transparent;"
            no-data-text="Podaci ne postoje za odabranu kategoriju"
            :search="search_text"
            :loading="is_loading"
            :items="items"
            :headers="headers"
            :options="{ itemsPerPage: 50 }"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, -1],
              'items-per-page-text': 'Broj zapisa po stranici',
              'items-per-page-all-text': 'Svi',
              'page-text': '{0}-{1} od {2}',
            }"
          >
            <template v-slot:[`item.supplier_naziv`]="{ item }">
              <div class="body-2" style="font-weight: 500;">
                {{ item.supplier_naziv }}
              </div>
            </template>
            <template v-slot:[`item.uplaceno_datum`]="{ item }">
              {{ $moment(new Date(item.uplaceno_datum)).format("L") }}
            </template>
            <template v-slot:[`item.uplaceno_km`]="{ item }">
              {{ $n(item.uplaceno_km) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon @click="open_item(item.id)"
                ><v-icon>mdi-open-in-new</v-icon></v-btn
              >
            </template>

            <template v-slot:[`item.kompletna`]="{ item }">
              <v-icon color="green" v-if="item.kompletna"
                >mdi-check-bold</v-icon
              >
              <v-icon color="error" v-else>mdi-close-thick</v-icon>
            </template>
            <template v-slot:[`item.referenca`]="{ item }">
              <div style="display:grid;grid-template-columns: max-content 1fr">
                <div class="mt-2 mb-2">
                  <div>{{ item.referenca }}</div>
                </div>
              </div>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    sabira_invoice_header: () => import("@/components/invoice_header"),
    sabira_invoice_progress_bar: () =>
      import("@/components/invoice_progress_bar"),
  },
  name: "Isplate",
  data() {
    return {
      is_loading: true,
      items: [],
      total_billed: 0,
      search_text: null,
      selected_id: null,
      selected_year: new Date().getFullYear(),
      years: [
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 4,
        new Date().getFullYear() - 5,
      ],
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: true,
          align: "left d-none",
        },
        {
          text: "Referenca sa izvoda",
          value: "referenca",
          sortable: true,
          align: "left",
          width: 200,
        },
        {
          text: "Opis troška",
          value: "trosak_opis",
          sortable: true,
          align: "left",
        },
        {
          text: "Dobavljač",
          value: "supplier_naziv",
          sortable: true,
          align: "left",
        },
        {
          text: "Datum isplate",
          value: "uplaceno_datum",
          sortable: true,
          align: "left",
          width: 160,
        },
        {
          text: "Isplaćeno",
          value: "uplaceno_km",
          sortable: true,
          align: "right",
        },
        {
          text: null,
          value: "actions",
          width: 20,
        },
      ],
    };
  },
  watch: {
    selected_year: {
      handler() {
        this.get_items();
      },
      immediate: false,
    },
  },
  computed: {
    total_paid() {
      if (this.items.length > 0) {
        return this.items
          .map((x) => x.uplaceno_km)
          .reduce((a, b) => {
            return a + b;
          });
      }
      return 0;
    },
  },
  methods: {
    new_item() {
      this.$webpageEventBus.$emit("show_expense_payment", 0);
    },
    get_total_billed() {
      this.$http({
        method: "POST",
        url: "/reports/widgets/expenses/month_on_month",
        data: {
          year: this.selected_year,
          account_id: this.$store.getters.user.account_id,
        },
      }).then((resp) => {
        this.total_billed = 0;
        resp.data.forEach((m) => {
          this.total_billed += m.total;
        });
      });
    },
    get_items() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/isplate/",
        data: {
          supplier_id: 0,
          account_id: this.$store.getters.user.account_id,
          year: this.selected_year,
        },
      })
        .then((resp) => {
          this.items = resp.data[0];
          this.get_total_billed();
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    open_item(id) {
      this.selected_id = id;
      this.$webpageEventBus.$emit("show_expense_payment", this.selected_id);
    },
  },
  beforeMount() {
    this.get_items();
  },
  mounted() {
    this.$webpageEventBus.$on("close_expense_payment", () => {
      this.selected_id = null;
      this.get_items();
    });

    this.$webpageEventBus.$on("reload_data", () => {
      this.get_items();
    });
    this.$webpageEventBus.$emit("toggle_navigation");
  },
};
</script>

<style scoped>
.gradient {
  background-image: linear-gradient(to right, #6172ca, #6cadd8);
}
.select {
  width: 94px;
}
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
